import script from "./PaymentPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentPopup.vue?vue&type=script&setup=true&lang=js"

import "./PaymentPopup.vue?vue&type=style&index=0&id=6fc62aaf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc62aaf"]])

export default __exports__